import Usuario from './Usuario'
import AutoInfracaoTransito from "./AutoInfracaoTransito";
import TipoVeiculo from "./TipoVeiculo";
import GrupoMarcaModelo from "./GrupoMarcaModelo";
import Talonario from "./Talonario";
import StatusAutoInfracaoTransito from "./StatusAutoInfracaoTransito";
import OrgaoAutuacao from "./OrgaoAutuacao";
import MensagemErro from "./MensagemErro";
import {helperDatas} from "../helpers";

class AitTalaoManual {
    constructor(
        {
            id = null,
            hash=null,
            auto_infracao_transito_id = null,
            talonario_id = null,
            status_auto_infracao_transito_id = null,
            orgao_autuacao_id = null,
            num_ait_composto = null,
            diretorio_original = null,
            diretorio_data_infracao = null,
            ait_digitalizado_upload = null,
            ait_digitalizado_hash = null,
            ait_digitalizado_mimetype = null,
            ait_digitalizado_nome_minio = null,
            ind_problema_triagem = false,
            cancelar = false,
            data_triagem = helperDatas.dataAtual(),
            usuario_responsavel_triagem_id = null,
            data_digitacao = null,
            usuario_responsavel_digitacao_id = null,
            placa_veiculo = null,
            tipo_veiculo_id = null,
            grupo_marca_modelo_id = null,
            mensagem_erro_id = null,
            created_at = null,
            updated_at = null,
            deleted_at = null,
            usuario_id = null,
            observacao = null,
            endereco = {},

            //ORM
            auto_infracao_transito = {},
            talonario = {},
            status_auto_infracao_transito = {},
            orgao_autuacao = {},
            tipo_veiculo = {},
            grupo_marca_modelo = {},
            mensagem_erro = {},
            usuario_responsavel_digitacao = {},
            usuario_responsavel_triagem = {},
            usuario = {},


        } = {}
    ) {

        this.id = id;
        this.hash=hash,
        this.auto_infracao_transito_id = auto_infracao_transito_id;
        this.talonario_id = talonario_id;
        this.status_auto_infracao_transito_id = status_auto_infracao_transito_id;
        this.orgao_autuacao_id = orgao_autuacao_id;
        this.num_ait_composto = num_ait_composto;
        this.diretorio_original = diretorio_original;
        this.diretorio_data_infracao = diretorio_data_infracao;
        this.ait_digitalizado_upload = ait_digitalizado_upload;
        this.ait_digitalizado_hash = ait_digitalizado_hash;
        this.ait_digitalizado_mimetype = ait_digitalizado_mimetype;
        this.ind_problema_triagem = ind_problema_triagem ? true : false;
        this.cancelar = cancelar ? true : false;
        this.data_triagem = data_triagem ? data_triagem : helperDatas.dataAtual();
        this.usuario_responsavel_triagem_id = usuario_responsavel_triagem_id;
        this.data_digitacao = data_digitacao;
        this.usuario_responsavel_digitacao_id = usuario_responsavel_digitacao_id;
        this.placa_veiculo = placa_veiculo;
        this.tipo_veiculo_id = tipo_veiculo_id;
        this.grupo_marca_modelo_id = grupo_marca_modelo_id;
        this.mensagem_erro_id = mensagem_erro_id;
        this.ait_digitalizado_nome_minio = ait_digitalizado_nome_minio;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;
        this.usuario_id = usuario_id;
        this.observacao = observacao;
        this.endereco = endereco;

        //ORM
        this.auto_infracao_transito = auto_infracao_transito ? new AutoInfracaoTransito(auto_infracao_transito) : new AutoInfracaoTransito();
        this.talonario = talonario ? new Talonario(talonario) : new Talonario();
        this.status_auto_infracao_transito = status_auto_infracao_transito ? new StatusAutoInfracaoTransito(status_auto_infracao_transito) : new StatusAutoInfracaoTransito();
        this.orgao_autuacao = orgao_autuacao ? new OrgaoAutuacao(orgao_autuacao) : new OrgaoAutuacao();
        this.tipo_veiculo = tipo_veiculo ? new TipoVeiculo(tipo_veiculo) : new TipoVeiculo();
        this.grupo_marca_modelo = grupo_marca_modelo ? new GrupoMarcaModelo(grupo_marca_modelo) : new GrupoMarcaModelo();
        this.mensagem_erro = mensagem_erro ? new MensagemErro(mensagem_erro) : new MensagemErro();
        this.usuario_responsavel_digitacao = usuario_responsavel_digitacao ? new Usuario(usuario_responsavel_digitacao) : new Usuario();
        this.usuario_responsavel_triagem = usuario_responsavel_triagem ? new Usuario(usuario_responsavel_triagem) : new Usuario();
        this.usuario = usuario ? new Usuario(usuario) : new Usuario();
    }
}

export default AitTalaoManual;